// Conversion utilities for unit conversion
const UNIT_CONVERSIONS: Record<
  string,
  { toStorage: number; storageUnit: string }
> = {
  kcal: { toStorage: 1, storageUnit: 'kcal' }, // kcal → kcal
  ml: { toStorage: 1, storageUnit: 'ml' }, // ml → ml
  g: { toStorage: 1000, storageUnit: 'mg' }, // g → mg (multiply by 1000)
  mg: { toStorage: 1, storageUnit: 'mg' }, // mg → mg
  mcg: { toStorage: 1, storageUnit: 'mcg' } // mcg → mcg
};

const FOOD_NUTRIENTS: Record<string, FoodNutrient> = {
  NANG_LUONG: {
    id: 1,
    name: 'ENERGY',
    title: 'Năng lượng',
    isRequired: true,
    unit: 'kcal'
  },
  NUOC: {
    id: 2,
    name: 'WATER',
    title: 'Nước',
    isRequired: false,
    unit: 'ml'
  },
  CHAT_DAM: {
    id: 3,
    name: 'PROTEIN',
    title: 'Chất đạm',
    isRequired: true,
    unit: 'g'
  },
  CHAT_DAM_DONG_VAT: {
    id: 4,
    name: 'ANIMAL_PROTEIN',
    title: 'Chất đạm động vật',
    isRequired: false,
    unit: 'g'
  },
  CHAT_DAM_THUC_VAT: {
    id: 5,
    name: 'VEGETABLE_PROTEIN',
    title: 'Chất đạm thực vật',
    isRequired: false,
    unit: 'g'
  },
  CHAT_BEO: {
    id: 6,
    name: 'FAT',
    title: 'Chất béo',
    isRequired: true,
    unit: 'g'
  },
  CHAT_BEO_DONG_VAT: {
    id: 7,
    name: 'ANIMAL_FAT',
    title: 'Chất béo động vật',
    isRequired: false,
    unit: 'g'
  },
  CHAT_BEO_THUC_VAT: {
    id: 8,
    name: 'VEGETABLE_FAT',
    title: 'Chất béo thực vật',
    isRequired: false,
    unit: 'g'
  },
  CHAT_BOT_DUONG: {
    id: 9,
    name: 'STARCH_SUGAR',
    title: 'Chất bột đường',
    isRequired: true,
    unit: 'g'
  },
  CHAT_XO: {
    id: 10,
    name: 'FIBER',
    title: 'Chất xơ',
    isRequired: false,
    unit: 'g'
  },
  CANXI: {
    id: 11,
    name: 'CANXI',
    title: 'Canxi',
    isRequired: false,
    unit: 'mg'
  },
  SAT: {
    id: 12,
    name: 'IRON',
    title: 'Sắt',
    isRequired: false,
    unit: 'mg'
  },
  KEM: {
    id: 13,
    name: 'ZINC',
    title: 'Kẽm',
    isRequired: false,
    unit: 'mg'
  },
  VITAMIN_D: {
    id: 14,
    name: 'VITAMIN_D',
    title: 'Vitamin D',
    isRequired: false,
    unit: 'mcg'
  },
  FOLATE: {
    id: 15,
    name: 'FOLATE',
    title: 'Folate',
    isRequired: false,
    unit: 'mcg'
  },
  AXIT_FOLIC: {
    id: 16,
    name: 'AXIT_FOLIC',
    title: 'Axit folic',
    isRequired: false,
    unit: 'mcg'
  },
  VITAMIN_B12: {
    id: 17,
    name: 'VITAMIN_B12',
    title: 'Vitamin B12',
    isRequired: false,
    unit: 'mcg'
  },
  MUOI: {
    id: 18,
    name: 'SALT',
    title: 'Muối',
    isRequired: false,
    unit: 'mg'
  },
  VITAMIN_B1: {
    id: 19,
    name: 'VITAMIN_B1',
    title: 'Vitamin B1',
    isRequired: false,
    unit: 'mcg'
  },
  MONO_UNSATURATED_FAT: {
    id: 20,
    name: 'MONO_UNSATURATED_FAT',
    title: 'Mono unsaturated fat',
    isRequired: false,
    unit: 'g'
  },
  POLY_UNSATURATED_FAT: {
    id: 21,
    name: 'POLY_UNSATURATED_FAT',
    title: 'Poly unsaturated fat',
    isRequired: false,
    unit: 'g'
  },
  TOTAL_UNSATURATED_FAT: {
    id: 22,
    name: 'TOTAL_UNSATURATED_FAT',
    title: 'Total unsaturated fat',
    isRequired: false,
    unit: 'g'
  },
  CHOLESTEROL: {
    id: 23,
    name: 'CHOLESTEROL',
    title: 'Cholesterol',
    isRequired: false,
    unit: 'mg'
  },
  DUONG: {
    id: 24,
    name: 'SUGAR',
    title: 'Đường',
    isRequired: false,
    unit: 'g'
  },
  KALI: {
    id: 25,
    name: 'KALI',
    title: 'Kali',
    isRequired: false,
    unit: 'g'
  },
  NATRI: {
    id: 26,
    name: 'NATRI',
    title: 'Natri',
    isRequired: false,
    unit: 'mg'
  },
  CLO: {
    id: 27,
    name: 'CLO',
    title: 'Clo',
    isRequired: false,
    unit: 'mg'
  },
  PHOSPHO: {
    id: 28,
    name: 'PHOSPHO',
    title: 'Phospho',
    isRequired: false,
    unit: 'mg'
  },
  MAGIE: {
    id: 29,
    name: 'MAGIE',
    title: 'Magiê',
    isRequired: false,
    unit: 'mg'
  },
  IOD: {
    id: 30,
    name: 'IOD',
    title: 'Iod',
    isRequired: false,
    unit: 'mcg'
  },
  SELEN: {
    id: 31,
    name: 'SELEN',
    title: 'Selen',
    isRequired: false,
    unit: 'mcg'
  },
  DONG: {
    id: 32,
    name: 'COPPER',
    title: 'Đồng',
    isRequired: false,
    unit: 'mcg'
  },
  CROM: {
    id: 33,
    name: 'CROM',
    title: 'Crom',
    isRequired: false,
    unit: 'mcg'
  },
  MANGAN: {
    id: 34,
    name: 'MANGAN',
    title: 'Mangan',
    isRequired: false,
    unit: 'mg'
  },
  FLUO: {
    id: 35,
    name: 'FLUO',
    title: 'Fluo',
    isRequired: false,
    unit: 'mg'
  },
  VITAMIN_A: {
    id: 36,
    name: 'VITAMIN_A',
    title: 'Vitamin A',
    isRequired: false,
    unit: 'mcg'
  },
  VITAMIN_K: {
    id: 37,
    name: 'VITAMIN_K',
    title: 'Vitamin K',
    isRequired: false,
    unit: 'mcg'
  },
  VITAMIN_E: {
    id: 38,
    name: 'VITAMIN_E',
    title: 'Vitamin E',
    isRequired: false,
    unit: 'mg'
  },
  VITAMIN_B2: {
    id: 39,
    name: 'VITAMIN_B2',
    title: 'Vitamin B2',
    isRequired: false,
    unit: 'mg'
  },
  VITAMIN_B3: {
    id: 40,
    name: 'VITAMIN_B3',
    title: 'Vitamin B3',
    isRequired: false,
    unit: 'mg'
  },
  VITAMIN_B5: {
    id: 41,
    name: 'VITAMIN_B5',
    title: 'Vitamin B5',
    isRequired: false,
    unit: 'mg'
  },
  VITAMIN_B6: {
    id: 42,
    name: 'VITAMIN_B6',
    title: 'Vitamin B6',
    isRequired: false,
    unit: 'mg'
  },
  VITAMIN_B9: {
    id: 43,
    name: 'VITAMIN_B9',
    title: 'Vitamin B9',
    isRequired: false,
    unit: 'mg'
  },
  BIOTIN: {
    id: 44,
    name: 'BIOTIN',
    title: 'Biotin',
    isRequired: false,
    unit: 'mcg'
  },
  CHOLINE: {
    id: 45,
    name: 'CHOLINE',
    title: 'Choline',
    isRequired: false,
    unit: 'mg'
  },
  VITAMIN_C: {
    id: 46,
    name: 'VITAMIN_C',
    title: 'Vitamin C',
    isRequired: false,
    unit: 'mg'
  },
  RETINOL: {
    id: 47,
    name: 'RETINOL',
    title: 'Retinol',
    isRequired: false,
    unit: 'mcg'
  },
  A_CAROTENE: {
    id: 48,
    name: 'A_CAROTINE',
    title: 'a-carotene',
    isRequired: false,
    unit: 'mcg'
  },
  B_CAROTENE: {
    id: 49,
    name: 'B_CAROTINE',
    title: 'b-carotene',
    isRequired: false,
    unit: 'mcg'
  },
  B_CRYPTOXANTHIN: {
    id: 50,
    name: 'B_CRYPTOXANTHIN',
    title: 'b-cryptoxanthin',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_1: {
    id: 51,
    name: 'BACK_UP_1',
    title: 'Dự phòng 1',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_2: {
    id: 52,
    name: 'BACK_UP_2',
    title: 'Dự phòng 2',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_3: {
    id: 53,
    name: 'BACK_UP_3',
    title: 'Dự phòng 3',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_4: {
    id: 54,
    name: 'BACK_UP_4',
    title: 'Dự phòng 4',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_5: {
    id: 55,
    name: 'BACK_UP_5',
    title: 'Dự phòng 5',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_6: {
    id: 56,
    name: 'BACK_UP_6',
    title: 'Dự phòng 6',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_7: {
    id: 57,
    name: 'BACK_UP_7',
    title: 'Dự phòng 7',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_8: {
    id: 58,
    name: 'BACK_UP_8',
    title: 'Dự phòng 8',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_9: {
    id: 59,
    name: 'BACK_UP_9',
    title: 'Dự phòng 9',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_10: {
    id: 60,
    name: 'BACK_UP_10',
    title: 'Dự phòng 10',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_11: {
    id: 61,
    name: 'BACK_UP_11',
    title: 'Dự phòng 11',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_12: {
    id: 62,
    name: 'BACK_UP_12',
    title: 'Dự phòng 12',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_13: {
    id: 63,
    name: 'BACK_UP_13',
    title: 'Dự phòng 13',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_14: {
    id: 64,
    name: 'BACK_UP_14',
    title: 'Dự phòng 14',
    isRequired: false,
    unit: 'mcg'
  },
  BACK_UP_15: {
    id: 65,
    name: 'BACK_UP_15',
    title: 'Dự phòng 15',
    isRequired: false,
    unit: 'mcg'
  }
};

/**
 * Convert value from UI display unit to backend storage unit
 * @param value - The value in UI unit
 * @param nutrient - The nutrient definition with unit info
 * @returns The converted value for backend storage
 */
export const convertToBackendUnit = (
  value: number | null | undefined,
  nutrient: FoodNutrient
): number | null => {
  if (value === null || value === undefined) return null;
  const conversion = UNIT_CONVERSIONS[nutrient.unit];
  if (!conversion) return value;
  return value * conversion.toStorage;
};

/**
 * Convert value from backend storage unit to UI display unit
 * @param value - The value in backend storage unit
 * @param nutrient - The nutrient definition with unit info
 * @returns The converted value for UI display
 */
export const convertFromBackendUnit = (
  value: number | null | undefined,
  nutrient: FoodNutrient
): number | null => {
  if (value === null || value === undefined) return null;
  const conversion = UNIT_CONVERSIONS[nutrient.unit];
  if (!conversion) return value;
  return value / conversion.toStorage;
};

/**
 * Batch convert all nutrient values from UI units to backend storage units
 * @param data - Object containing nutrient values
 * @returns Object with converted values
 */
export const convertBatchToBackendUnits = (
  data: Record<string, any>
): Record<string, any> => {
  const converted = { ...data };

  // Nutrients stored in 'mg' that should display as 'g' (divide by 1000)
  const mgToGrams = [
    'CANXI',
    'IRON',
    'ZINC',
    'SALT',
    'VITAMIN_B2',
    'VITAMIN_E',
    'VITAMIN_B3',
    'VITAMIN_B5',
    'VITAMIN_B6',
    'VITAMIN_B9',
    'CHOLINE',
    'VITAMIN_C',
    'CHOLESTEROL',
    'NATRI',
    'CLO',
    'PHOSPHO',
    'MAGIE',
    'MANGAN',
    'FLUO'
  ];

  const mcgToGrams = [
    'VITAMIN_D',
    'FOLATE',
    'AXIT_FOLIC',
    'VITAMIN_B12',
    'VITAMIN_B1',
    'IOD',
    'SELEN',
    'COPPER',
    'CROM',
    'VITAMIN_A',
    'VITAMIN_K',
    'BIOTIN',
    'RETINOL',
    'A_CAROTINE',
    'B_CAROTINE',
    'B_CRYPTOXANTHIN',
    'BACK_UP_1',
    'BACK_UP_2',
    'BACK_UP_3',
    'BACK_UP_4',
    'BACK_UP_5',
    'BACK_UP_6',
    'BACK_UP_7',
    'BACK_UP_8',
    'BACK_UP_9',
    'BACK_UP_10',
    'BACK_UP_11',
    'BACK_UP_12',
    'BACK_UP_13',
    'BACK_UP_14',
    'BACK_UP_15'
  ];

  for (const nutrientName of mgToGrams) {
    if (
      nutrientName in converted &&
      converted[nutrientName] !== null &&
      converted[nutrientName] !== undefined
    ) {
      const numValue =
        typeof converted[nutrientName] === 'string'
          ? parseFloat(converted[nutrientName])
          : converted[nutrientName];
      converted[nutrientName] = String(numValue / 1000);
    }
  }

  for (const nutrientName of mcgToGrams) {
    if (
      nutrientName in converted &&
      converted[nutrientName] !== null &&
      converted[nutrientName] !== undefined
    ) {
      const numValue =
        typeof converted[nutrientName] === 'string'
          ? parseFloat(converted[nutrientName])
          : converted[nutrientName];
      converted[nutrientName] = String(numValue / 1000000);
    }
  }

  return converted;
};

/**
 * Batch convert all nutrient values from backend storage units to UI display units
 * @param data - Object containing nutrient values from backend
 * @returns Object with converted values for display
 */
export const convertBatchFromBackendUnits = (
  data: Record<string, any>
): Record<string, any> => {
  const converted = { ...data };

  // Nutrients with unit 'g' → convert to 'mg' (multiply by 1000)
  const gramsToMg = [
    'CANXI',
    'IRON',
    'ZINC',
    'SALT',
    'VITAMIN_B2',
    'VITAMIN_E',
    'VITAMIN_B3',
    'VITAMIN_B5',
    'VITAMIN_B6',
    'VITAMIN_B9',
    'CHOLINE',
    'VITAMIN_C',
    'CHOLESTEROL',
    'NATRI',
    'CLO',
    'PHOSPHO',
    'MAGIE',
    'MANGAN',
    'FLUO'
  ];

  const gramsToMcg = [
    'VITAMIN_D',
    'FOLATE',
    'AXIT_FOLIC',
    'VITAMIN_B12',
    'VITAMIN_B1',
    'IOD',
    'SELEN',
    'COPPER',
    'CROM',
    'VITAMIN_A',
    'VITAMIN_K',
    'BIOTIN',
    'RETINOL',
    'A_CAROTINE',
    'B_CAROTINE',
    'B_CRYPTOXANTHIN',
    'BACK_UP_1',
    'BACK_UP_2',
    'BACK_UP_3',
    'BACK_UP_4',
    'BACK_UP_5',
    'BACK_UP_6',
    'BACK_UP_7',
    'BACK_UP_8',
    'BACK_UP_9',
    'BACK_UP_10',
    'BACK_UP_11',
    'BACK_UP_12',
    'BACK_UP_13',
    'BACK_UP_14',
    'BACK_UP_15'
  ];

  for (const nutrientName of gramsToMg) {
    if (
      nutrientName in converted &&
      converted[nutrientName] !== null &&
      converted[nutrientName] !== undefined
    ) {
      const numValue =
        typeof converted[nutrientName] === 'string'
          ? parseFloat(converted[nutrientName])
          : converted[nutrientName];
      converted[nutrientName] = (numValue * 1000).toFixed(2);
    }
  }

  for (const nutrientName of gramsToMcg) {
    if (
      nutrientName in converted &&
      converted[nutrientName] !== null &&
      converted[nutrientName] !== undefined
    ) {
      const numValue =
        typeof converted[nutrientName] === 'string'
          ? parseFloat(converted[nutrientName])
          : converted[nutrientName];
      converted[nutrientName] = (numValue * 1000000).toFixed(2);
    }
  }

  return converted;
};

export default FOOD_NUTRIENTS;
